import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { User } from '../../../../../../shared/models/UserModels';
import ResendInvitesModal from './ResendInvitesModal';
import { addUsersResend, usersResendList } from '../../../resendActionSlice';
import { useResendUserInvitesBulkActionMutation } from './apiSlice';
import { accountSelector } from '../../../../../../shared/store/shared/accountSlice';
import { toastWithAnalytics } from '../../../../../../shared/analytics';

export default function ResendInvitesAction({
  onActionComplete,
  selectedUsers,
}: {
  onActionComplete: () => void;
  selectedUsers: User[];
}) {
  const dispatch = useDispatch();
  const { currentAccountId } = useSelector(accountSelector);
  const resendList = useSelector(usersResendList);
  const [resendInvitation, resendInvitationRequest] =
    useResendUserInvitesBulkActionMutation();
  const resentInvitesTo = selectedUsers.filter(
    (e) =>
      (e.invitationStatus === 'Pending' || e.personId === 0) &&
      !resendList.includes(e.email),
  );
  const [showEditUsersModal, setShowEditUsersModal] = useState(true);

  if (showEditUsersModal) {
    return (
      <ResendInvitesModal
        onCancel={() => {
          onActionComplete();
          setShowEditUsersModal(false);
        }}
        selectedUsers={resentInvitesTo}
        onSubmit={(e: Event | any) => {
          e.target.disabled = true;
          const accountIds: string[] = resentInvitesTo.map((user) =>
            user.id.toString(),
          );
          resendInvitation({
            accountId: currentAccountId,
            accountUserIds: accountIds,
          })
            .unwrap()
            .then(() => {
              toastWithAnalytics(
                `${accountIds.length} invites ${
                  accountIds.length > 1 ? 'have' : 'has'
                } been resent successfully.`,
                'success',
              );
              resentInvitesTo.map((user) =>
                dispatch(addUsersResend(user.email)),
              );
              resendInvitationRequest.reset();
              onActionComplete();
            })
            .catch(() => {
              toastWithAnalytics(
                'Could not resend invitations. Please try again.',
                'danger',
              );
              e.target.disabled = false;
            });
        }}
      />
    );
  }
  return null;
}
